import SimpleSlider from "../simpleSlider";

let mainSlider = document.querySelector('.js-main-slider');
 
if (mainSlider !== null) {
    new SimpleSlider(mainSlider);
}